export const isValidEmail = (mail: string) => /^[^\s]+@[^.][\w.-]*\.[\w-]{2,63}$/u.test(mail);
export const isValidListOfEmails = (emails?: string) => emails && emails.trim().split(/\s*[;|,]\s*/).every(isValidEmail);
